import {
	type GoalFormModel,
	RENT_DRAWDOWN_MODES,
	type RentDrawdownMode,
} from "web_myplann/Goals/Forms/useGoalForm";
import { GoalCategoryTypeEnum } from "web_myplann/Infrastructure/Api/Api";
import { getTypedParam } from "web_myplann/Shared/Utils/getTypedParam";
import { parseDate } from "web_myplann/Shared/Utils/parseDate";
import { isEnumValue } from "web_myplann/Shared/Utils/parsers";

const parseCategory = (raw: string | null): GoalCategoryTypeEnum | undefined =>
	isEnumValue(GoalCategoryTypeEnum, raw) ? raw : undefined;

const isRentDrawdownMode = (raw: string): raw is RentDrawdownMode =>
	(RENT_DRAWDOWN_MODES as readonly string[]).includes(raw);

const parseDrawdownMode = (
	raw: string | null,
): RentDrawdownMode | undefined => {
	if (!raw) return undefined;
	return isRentDrawdownMode(raw) ? raw : undefined;
};

export const mapParamsToGoalForm = (
	params: URLSearchParams,
): Partial<GoalFormModel> => ({
	category: parseCategory(params.get("category")),
	name: getTypedParam(params, "name", String),
	totalValue: getTypedParam(params, "totalValue", Number),
	ownFunds: getTypedParam(params, "ownFunds", Number),
	loanAmount: getTypedParam(params, "loanAmount", Number),
	monthlyRent: getTypedParam(params, "monthlyRent", Number),
	drawdownMode: parseDrawdownMode(params.get("drawdownMode")),
	dueDate: parseDate(params.get("dueDate")),
});
